import z from 'zod';
export const NotificationId = {
    documentValidation: 'documentValidation',
    employeeDebts: 'employeeDebts',
    employeeCredits: 'employeeCredits',
    ticketStock: 'ticketStock',
    pendingPayments: 'pendingPayments',
    supplierInvoices: 'supplierInvoices',
    billetterieOrders: 'billetterieOrders',
};
export const NOTIFICATION_IDS = Object.values(NotificationId);
export const DEFAULT_CONSOLE_NOTIFICATIONS = [...NOTIFICATION_IDS];
export const baseConsoleNotifications = {
    select: {
        id: true,
        userId: true,
        notifications: true,
    },
};
export const NotificationIdSchema = z.enum(Object.values(NotificationId));
export const updateConsoleNotificationsSchema = z.object({
    notifications: z.array(NotificationIdSchema),
});
